import { hideTutorial } from '@/store/features/tutorialSlice'
import { RootState } from '@/store/store'
import { X } from 'lucide-react'
import { useDispatch, useSelector } from 'react-redux'
import { useRef, useEffect } from 'react'

const DisplayTutorial = () => {
  const isOpen = useSelector(
    (state: RootState) => state.tutorial.displayTutorial
  )
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(hideTutorial())
  }

  const handleVideoEnd = () => {
    dispatch(hideTutorial())
  }

  if (!isOpen) return null

  return (
    <DisplayVideo
      videoSrc="https://aicade-ui-assets.s3.us-east-1.amazonaws.com/tutorial.mp4"
      onEnded={handleVideoEnd}
      onClose={handleClose}
    />
  )
}

export default DisplayTutorial

const DisplayVideo = ({ videoSrc, onEnded, onClose }) => {
  const videoRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (videoRef.current && !videoRef.current.contains(event.target)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [onClose])

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="relative" ref={videoRef}>
        <button
          onClick={onClose}
          className="absolute -right-4 -top-4 z-10 flex size-8 items-center justify-center rounded-full bg-white/80 shadow-md transition-colors hover:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <X className="size-5 text-gray-800" />
          <span className="sr-only">Close</span>
        </button>
        <video
          autoPlay
          controls
          className="max-h-[70vh] max-w-[70vw]"
          onEnded={onEnded}
        >
          <source src={videoSrc} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  )
}
